export default __webpack_public_path__ + "static/media/referal-mail.c0ac6cc0.svg";